import { TableEmptyState } from '@practium/ui';
import { formatDateFromISO } from '@practium/shared';
import { CATEGORY_LABELS, STATUS_LABELS } from '../../../types/productRequest.types';
import styles from './ProductRequestsTable.module.css';
import { RequestProduct } from '@practium/features/products/types';

interface ProductRequestsTableProps {
	requests: RequestProduct[];
	onRowClick?: (request: RequestProduct) => void;
}

const STATUS_CLASS: Record<string, string> = {
	PENDING: styles.badgePending,
	APPROVED: styles.badgeApproved,
	REJECTED: styles.badgeRejected,
};

export const ProductRequestsTable = ({ requests, onRowClick }: ProductRequestsTableProps) => {
	if (requests.length === 0) {
		return (
			<TableEmptyState
				title="Nenhuma solicitação encontrada"
				subtitle="As solicitações de produtos aparecerão aqui"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome</th>
						<th>Fabricante</th>
						<th>Categoria</th>
						<th>Solicitante</th>
						<th>Data</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{requests.map(item => (
						<tr
							key={item._id}
							onClick={() => onRowClick?.(item)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.manufacturer}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{CATEGORY_LABELS[item.category]}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.userName}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{formatDateFromISO(item.createdAt)}</span>
							</td>
							<td>
								<span className={`${styles.badge} ${STATUS_CLASS[item.status]}`}>
									{STATUS_LABELS[item.status]}
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
